import HeroComponent from '../components/hero';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class NeweggbitesController{

  constructor(options) {
    this.options = options;
    console.log('New EGG Bites! CONTROLLER');

    this.transitionIn();
    this.updateUI();

    // track the scroll position
    $(window).scroll( e => this.handleScroll(e) );

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });

    $('.anchorAnimate').anchorAnimate();


    $('#pizzadeluxe').hover( () => {
      $( '.logos .pizzadeluxe' ).addClass('active');
    }, () => {
      $( '.logos .pizzadeluxe' ).removeClass('active');
    });
    $('#texmex').hover( () => {
      $( '.logos .texmex' ).addClass('active');
    }, () => {
      $( '.logos .texmex' ).removeClass('active');
    });

    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });

  }

  transitionIn() {

    // reveal the home hero text
    $('.anniversary__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      $('.anniversary__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

  }

  updateUI() {
    const st = $(window).scrollTop();
    const trig1 = $(window).height() * 0.75;
    const trig2 = $(window).height() * 0.35;
    // const trig3 = $(window).height() * 0.15;

  }

  handleScroll() {
    this.updateUI();
  }

}
jQuery.fn.anchorAnimate = function(settings) {

    settings = jQuery.extend({
        speed : 1000
    }, settings);

    return this.each(function(){
        var caller = this;
        $(caller).click(function (event) {
            event.preventDefault();
            var locationHref = window.location.href;
            var elementClick = $(caller).attr("href");

            var destination = $(elementClick).offset().top;
            $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, settings.speed, function() {
                window.location.hash = elementClick
            });

            return false;
        })
    })
}


// WEBPACK FOOTER //
// ./js/controllers/pages/NeweggbitesController.js